module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsPassport-24854757b2645a56ddbefb700c719708.png";